import { ActionTypes } from "../constants/action-types";

export const setSubscription = (val) => {
  return {
    type: ActionTypes.SET_SUBSCRIPTION,
    payload: val,
  };
};
